// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__DTUOc","logo":"LandingPage_logo__F00J4","content":"LandingPage_content__jS55C","buttonGroup":"LandingPage_buttonGroup__f80MH"};